import { STORAGE } from '../constants/formConstants';

export const getDrafts = () => {
  try {
    const drafts = [];
    const prefix = `${STORAGE.MULTI_FORM_PREFIX}newRequest_`;
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      
      if (key && key.startsWith(prefix)) {
        const data = localStorage.getItem(key);
        if (data) {
          try {
            const parsed = JSON.parse(data);
            if (parsed.draftId && parsed.timestamp) {
              drafts.push({
                draftId: parsed.draftId,
                draftName: parsed.draftName,
                workflowVersionId: parsed.workflowVersionId,
                formName: parsed.formName,
                timestamp: parsed.timestamp,
              });
            }
          } catch (parseError) {
            // Skip invalid draft entries
          }
        }
      }
    }
    
    return drafts.sort((a, b) => b.timestamp - a.timestamp);
  } catch (error) {
    return [];
  }
};

export const getDraftById = (draftId) => {
  try {
    const data = localStorage.getItem(draftId);
    if (data) {
      return JSON.parse(data);
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const deleteDraft = (draftId) => {
  try {
    localStorage.removeItem(draftId);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const saveDraft = (draftData, draftName) => {
  try {
    const timestamp = Date.now();
    const draftId = draftData.draftId || `${STORAGE.MULTI_FORM_PREFIX}newRequest_${draftData.workflowVersionId}_${timestamp}`;
    
    const dataToSave = {
      ...draftData,
      draftId,
      draftName: draftName || `Draft ${new Date(timestamp).toLocaleString('en-GB')}`,
      timestamp,
    };
    
    localStorage.setItem(draftId, JSON.stringify(dataToSave));
    return { success: true, draftId };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

